// extracted by mini-css-extract-plugin
export default {"sidepanel":"DashboardEditorPage_sidepanel__ihXfB","db":"DashboardEditorPage_db__9VwEl","draggable":"DashboardEditorPage_draggable__Y2mtY"};